var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMn9Vyk13Q3Spn24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2372_21424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0H6C2.688 0 0 2.67734 0 5.97899V13.1586V14.3592C0 17.6608 2.688 20.3382 6 20.3382H7.8C8.124 20.3382 8.556 20.5543 8.76 20.8184L10.56 23.2076C11.352 24.2641 12.648 24.2641 13.44 23.2076L15.24 20.8184C15.468 20.5183 15.828 20.3382 16.2 20.3382H18C21.312 20.3382 24 17.6608 24 14.3592V5.97899C24 2.67734 21.312 0 18 0ZM13.2 14.1071H6C5.508 14.1071 5.1 13.6988 5.1 13.2066C5.1 12.7144 5.508 12.3062 6 12.3062H13.2C13.692 12.3062 14.1 12.7144 14.1 13.2066C14.1 13.6988 13.692 14.1071 13.2 14.1071ZM18 8.10405H6C5.508 8.10405 5.1 7.69585 5.1 7.2036C5.1 6.71136 5.508 6.30315 6 6.30315H18C18.492 6.30315 18.9 6.71136 18.9 7.2036C18.9 7.69585 18.492 8.10405 18 8.10405Z",
    fill: "#516F93"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2372_21424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMn9Vyk13Q3Spn24);
export default __webpack_public_path__ + "static/media/mn9vyk13-q3spn24.a49a1dba42533af4cdde862896ba8d78.svg";
export { ForwardRef as ReactComponent };